<script>
import DaySelector from '@/components/organism/DaySelector'
import TimeSelector from '@/components/organism/TimeSelector'

export default {
    name: 'DateSelector',
    components: {
        DaySelector,
        TimeSelector,
    },
    props: {
        value: null,
        noLimit: Boolean,
        days: {
            type: Array,
            default: () => [],
        },
        times: {
            type: Array,
            default: () => [],
        },
        allowance: {
            type: Object,
            default: () => {},
        },
        restaurant: {
            type: Object,
            default: () => {},
        },
    },
    methods: {
        input(val) {
            this.$emit('input', val)
        },
    },
}
</script>

<template lang="pug">
    .date-selector
        day-selector(
            :value="value"
            :days="days"
            @input="input")
        time-selector(
            :value="value"
            :no-limit="noLimit"
            :times="times"
            :allowance="allowance"
            :restaurant="restaurant"
            @input="input")

</template>
